import request from 'src/lib/data/request'
import config from 'config'
import { isBrowser } from '../util/dom'

export default async function graph2(req, data, eid, ctx = {}) {
  const payload = {
    eid,
    data
  }

  const url = isBrowser
    ? `${config.NEXT_PUBLIC_API_URL}/graph2`
    : `${config.API_URL}/graph2`

  let res
  if (isBrowser || config.NEXT_PUBLIC_NODE_ENV === 'production') {
    res = await request(req, ctx).post(url).send(payload)
  } else {
    res = await request(req, ctx).post(url).disableTLSCerts().send(payload)
  }

  return res.body
}
